/**
 * Query Type Label Exporter
 * Exports minimal CSV: student_id, query_index, query_type
 * These labels come from GPT assessment stored in the DB
 * and cannot be recomputed from raw telemetry alone.
 */
import { getMessagesBetweenUserAndAI, AI_AGENT_ID } from '../../workspace/service/workspaceMessageService'

export async function buildQueryTypeExport(students, eventsByUser, sessionId) {
  const rows = []

  for (const student of students) {
    const events = eventsByUser[student.id] || eventsByUser[String(student.id)] || []
    if (events.length === 0) continue

    const queryEvents = events
      .filter(e => e.type === 'CHAT_QUERY')
      .sort((a, b) => a.timestamp - b.timestamp)

    if (queryEvents.length === 0) continue

    let dbMessages = []
    try {
      dbMessages = await getMessagesBetweenUserAndAI(student.id, sessionId)
    } catch (err) {
      console.error(`Failed to fetch messages for student ${student.id}:`, err)
      continue
    }

    const userMessages = dbMessages.filter(m => m.sender_id !== AI_AGENT_ID)

    queryEvents.forEach((qEvent, qIdx) => {
      const queryContent = qEvent.payload?.text || qEvent.payload?.message || qEvent.payload?.content || ''
      const dbMatch = userMessages.find(m => m.content === queryContent)

      rows.push({
        student_id: student.id,
        query_index: qIdx + 1,
        query_type: dbMatch?.query_type || '',
      })
    })
  }

  return rows
}

export function downloadQueryTypeCSV(rows, filename) {
  if (rows.length === 0) return

  const headers = ['student_id', 'query_index', 'query_type']
  const csv = [
    headers.join(','),
    ...rows.map(row => headers.map(h => {
      const v = row[h]
      if (typeof v === 'string' && (v.includes(',') || v.includes('"'))) {
        return `"${String(v).replace(/"/g, '""')}"`
      }
      return v ?? ''
    }).join(','))
  ].join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}